export default "__VITE_PUBLIC_ASSET__3db9fb1d__"